import { AUTH_MODE, keycloakAuthService } from '@/auth/keycloak'
import { AppRoutePaths } from '@/routing/route_paths'
import { purgeStore, RootState } from '@/storage/store'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

export const useSignOut = () => {
  const navigate = useNavigate()
  const AuthState = useSelector((state: RootState) => state.AuthSession)

  return () => {
    if (AUTH_MODE === 'keycloak' && AuthState.isAuthenticated)
      keycloakAuthService().logout(`${window.location.origin}/sso-logout`)
    else{
      purgeStore()
      navigate(AppRoutePaths.auth.login, { replace: true })
    }
  }
}
